import common from '../common'

export default {
    list(params) {
        return common.post('/rocheManage/authorize/queryAuthorizeUser',params);
    },
    stop(params) {
        return common.post('/rocheManage/authorize/stopAuthorize',params);
    },
    save(params) {
        return common.post('/rocheManage/authorize/saveAuthorizationInfo',params);
    },
    check(params) {
        return common.post('/rocheManage/authorize/checkAuthorizeUser',params);
    },
    selectUser(params) {
        return common.post('/rocheManage/authorize/selectUser',params);
    },
    team(params) {
        return common.post('/rocheManage/authorize/selectAuthorizationTeam',params);
    },
    approveUser(params) {
        return common.post('/rocheManage/authorize/selectApproveUser',params);
    },
}



// WEBPACK FOOTER //
// ./src/api/user/authorize.js